import { render, staticRenderFns } from "./SettingsLogin.vue?vue&type=template&id=1d68db60&scoped=true"
import script from "./SettingsLogin.vue?vue&type=script&lang=js"
export * from "./SettingsLogin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d68db60",
  null
  
)

export default component.exports